export default __webpack_public_path__ + "video/5_recruit_wizards.mp4";